import { FC } from 'react'
import { Box } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import theme from 'theme'
import { AssetSource } from 'models'
import { getIntegrationLogo } from 'lib/utils'
import { SourcePopperCard } from './assetDetailsPane.styles'
import { productTitle } from '../utils/assetSources'

interface Props {
  anchorEl: HTMLElement | null
  sources: AssetSource[]
  /* Keyed by instance; an instance without one renders as a plain row, not a dead link. */
  urls?: Record<string, string>
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const SourcePopover: FC<Props> = ({ anchorEl, sources, urls = {}, onMouseEnter, onMouseLeave }) => (
  <SourcePopperCard open={Boolean(anchorEl)} anchorEl={anchorEl} placement="bottom-start">
    <Box className="popper-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {sources.map((source) => {
        const url = urls[source.instance]

        const content = (
          <>
            <img src={getIntegrationLogo(source.product, 'circle')} alt="" />
            <Box className="product-names">
              <Box component="span" className="product-title">
                {productTitle(source.product)}
              </Box>
              {source.instance !== source.product && (
                <Box component="span" className="product-instance">
                  {source.displayName ?? source.instance}
                </Box>
              )}
            </Box>
            {url && (
              <Box component="span" className="origin-icon">
                <OpenInNewIcon sx={{ fontSize: theme.typography.fontSize.xLarge }} />
              </Box>
            )}
          </>
        )

        return url ? (
          <a key={source.instance} className="product-row" href={url} target="_blank" rel="noreferrer noopener">
            {content}
          </a>
        ) : (
          <Box key={source.instance} className="product-row">
            {content}
          </Box>
        )
      })}
    </Box>
  </SourcePopperCard>
)

export default SourcePopover
